export default __webpack_public_path__ + "static/blade-2962793e1932d5ccfc5304b5aaffb128.png";